import {Skeleton} from '@dropbox/dig-components/skeleton';
import {Box} from '@dropbox/dig-foundations';
import type {ComponentProps, ReactNode} from 'react';

type SkeletonWidth = ComponentProps<typeof Skeleton.Text>['width'];

// The rail's places (My workstreams, Audit, Company), then its folded pillars.
const PLACE_WIDTHS: SkeletonWidth[] = [112, 48, 64];
const PILLAR_WIDTHS: SkeletonWidth[] = [148, 96, 64, 112, 80, 120];

// Matches WorkstreamTree's group rows: 36px tall on an 8px inset (a folded
// pillar shows no chevron). Lower pillars fade, like the table's skeleton.
const SkeletonRow = ({width, opacity = 1}: {width: SkeletonWidth; opacity?: number}) => (
  <Box display="flex" alignItems="center" paddingLeft="8" style={{minHeight: 36, opacity}}>
    <Skeleton.Text size="small" width={width} />
  </Box>
);

/** The rail while its trees load: places, `divider`, then the pillars. */
export const NavTreeSkeleton = ({divider}: {divider: ReactNode}) => (
  <Box aria-busy="true" aria-label="Loading workstreams">
    {PLACE_WIDTHS.map((width, index) => (
      <SkeletonRow key={index} width={width} />
    ))}
    {divider}
    {PILLAR_WIDTHS.map((width, index) => (
      <SkeletonRow key={index} width={width} opacity={1 - index * 0.12} />
    ))}
  </Box>
);
